<template>
  <div id="privilege-history-list">
    <b-card
      no-body
      class="py-2 px-1 container-card"
    >
      <privilege-history-detail
        :reference="privilegeHistoryDetail.ref"
        :name-history-en="privilegeHistoryDetail.nameEn"
        :name-history-th="privilegeHistoryDetail.nameTh"
        :image-url="privilegeHistoryDetail.image"
      />
      <b-row class="mt-2 px-1">
        <b-col
          cols="12"
          class="px-2 mb-1"
        >
          <div>
            <div class="d-flex flex-wrap justify-content-end">
              <div
                class="search-container mb-1 mb-md-0 mr-0 ml-0 ml-xl-2 ml-lg-1"
              >
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col
          cols="12"
          class="mb-1"
        >
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="privilegeHistoryTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table normal-height"
              >
                <template #cell(code_ref)="data">
                  <div class="text-center" v-if="data.item.code.length <= 0">
                    -
                  </div>
                  <div v-else>
                    <div
                      v-for="item in data.item.code"
                      :key="item"
                      class="text-center"
                    >
                      <div class="text-left">
                        {{ item.code }}
                      </div>
                    </div>
                  </div>
                </template>
                <template #head(mobile_no)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(mobile_no)="data">
                  <div class="text-center">
                    {{ data.item.crm_mobile_no || '-' }}
                  </div>
                </template>
                <template #head(qty)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(qty)="data">
                  <div class="text-center">
                    {{ data.item.amount }}
                  </div>
                </template>
                <template #head(first_name)="data">
                  <div class="head-name">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(first_name)="data">
                  <div class="">
                    {{ data.item.crm_first_name_th || '-' }}
                  </div>
                </template>
                <template #head(last_name)="data">
                  <div class="head-name">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(last_name)="data">
                  <div class="">
                    {{ data.item.crm_last_name_th || '-' }}
                  </div>
                </template>
                <template #head(expire_date)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(expire_date)="data">
                  <div class="text-center col-date">
                    <div v-if="privilegeHistoryDetail.privilegeType == 4">
                      <div v-if="data.item.code.length <= 0">
                        -
                      </div>
                      <div v-else>
                        <div
                          v-for="item in data.item.code"
                          :key="item"
                          class="text-center"
                        >
                          <div class="text-center">
                            {{
                              item.expired_date
                                ? `${resolveDate(
                                  item.expired_date,
                                )} ${resolveFullTime(item.expired_date)}`
                                : '-'
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      {{
                        data.item.expired_date
                          ? `${resolveDate(
                            data.item.expired_date,
                          )} ${resolveFullTime(data.item.expired_date)}`
                          : '-'
                      }}
                    </div>
                  </div>
                </template>
                <template #head(updatedtime)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(updatedtime)="data">
                  <div class="text-center col-date">
                    {{
                      data.item.latest_update
                        ? `${resolveDate(
                          data.item.latest_update,
                        )} ${resolveFullTime(data.item.latest_update)}`
                        : '-'
                    }}
                  </div>
                </template>
                <template #head(order_date)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(order_date)="data">
                  <div class="text-center col-date">
                    {{
                      data.item.issue_date
                        ? `${resolveDate(
                          data.item.issue_date,
                        )} ${resolveFullTime(data.item.issue_date)}`
                        : '-'
                    }}
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col
          cols="12"
          class="my-1"
        >
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import Search from '@/views/components/search/Search.vue'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import privilegeHistoryDetail from './components/PrivilegeHistoryDetail.vue'
import usePrivilegeHistory from './hooks/usePrivilegeHistory'

export default {
  components: { Search, privilegeHistoryDetail, PaginationWithReorder },

  setup() {
    const {
      pagination,
      onPageChange,
      onFilterEntity,
      privilegeHistoryDetail,
      loading,
      fields,
      privilegeHistoryTable,
      resolveDate,
      resolveTime,
      resolveFullTime,
      onSetValueSearch,
    } = usePrivilegeHistory()

    return {
      pagination,
      onPageChange,
      onFilterEntity,
      privilegeHistoryDetail,
      loading,
      fields,
      privilegeHistoryTable,
      resolveDate,
      resolveTime,
      resolveFullTime,
      onSetValueSearch,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import '~@/assets/css/pages/privilege/privilege-history.css';
</style>
